import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2025 GreenTech - Surveillance Environnementale pour PME et ETI</p>
      </div>
    </footer>
  );
};

export default Footer;
